export const FULFILLMENT_LABELS = {
  BROWSE_ALL: 'Browse All',
  IN_STORE: 'In Store',
  DELIVERY: 'Delivery',
  FREE_DELIVERY: 'Free Delivery'
};

export const BROWSE_ALL_REFINEMENT = {
  value: 'browseAll',
  label: FULFILLMENT_LABELS.BROWSE_ALL,
  refinementKey: 'mock_browseAll'
};

export const FULFILLMENT_DIMENSIONS_LABELS = {
  instore: 'GET IT FAST',
  delivery: 'DELIVERY',
  freeDelivery: 'FREE DELIVERY'
};

export const DELIVERY_REFINEMENTS = {
  ANYTIME: 'Anytime',
  TODAY: 'Today',
  BY_TOMORROW: 'By Tomorrow'
};

export const DELIVERY_REFINEMENTS_LABELS = Object.values(DELIVERY_REFINEMENTS);

export const REFINEMENTS = {
  PICKUP_TODAY: 'Pick Up Today'
};

export const GET_IT_FAST_DIMENSION_LABEL = 'Get It Fast';

export const PLP_SPEED_DIMENSION_LABEL = 'In Store or Delivery';

export const IN_STORE_CHIP_DIMENSION_LABEL = 'Available';

export const VALID_IN_STORE_DIMENSION_LABELS = [
  FULFILLMENT_LABELS.IN_STORE,
  IN_STORE_CHIP_DIMENSION_LABEL,
  'Get It Fast'
];

export const FULFILLMENT_DIMENSION_LABELS_TO_CHECK = [
  ...(Object.values(FULFILLMENT_LABELS)),
  IN_STORE_CHIP_DIMENSION_LABEL,
  PLP_SPEED_DIMENSION_LABEL
];

export const RATINGS_REFINEMENT_KEY = 'bwo5q';
export const HIGHLY_RATED_REFINEMENT_KEY = 'bwo5o';
export const FILTER_LABEL = 'All Filters';
export const FILTER_SORT_LABEL = 'Filter & Sort';

export const ON_DISPLAY_ITEM = {
  label: 'Get It Fast',
  refinements: [{
    label: 'On Display',
    refinementLabel: 'On Display',
    refinementKey: 'onDisplay'
  }]
};

export const ScreenSize = {
  UNPREFIXED: 'unprefixed',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  X_LARGE: 'xl',
  DX_LARGE: '2xl'
};

export const MAX_REFINEMENTS = 5;
export const BEST_RATED = 'Best-Rated';
export const HIGH_RATED = 'Highly-Rated';

export const REGEX_PATTERNS = {
  parentheses: /\(([^)]+)\)/,
  plainUnit: /\d+\s+(\w+\.?\w*)/,
  general: /^(?!\d+$)(?:\b\d+(\.\d+)?\s*)(?:\(([^)]+)\)|(\w+))/
};

export const FIT_COMPATIBILITY_DIMENSIONS = [
  'DEPTH (EXCLUDING HANDLES) (IN.)',
  'HEIGHT TO TOP OF DOOR HINGE (IN.)',
  'HEIGHT TO TOP OF REFRIGERATOR (IN.)',
  'INSTALLATION DEPTH',
  'REFRIGERATOR FIT WIDTH',
  'TOTAL CAPACITY (CU. FT.)',
  'CAPACITY (CU. FT.) - REFRIGERATORS',
  'REFRIGERATOR CAPACITY (CU. FT.)',
  'DEPTH (INCLUDING HANDLES) (IN.)',
  'RANGE SIZE (WIDTH)',
  'OVERALL PRODUCT HEIGHT (IN.)',
  'REFRIGERATOR WIDTH (IN.)',
  'DRYER FIT WIDTH',
  'WASHER FIT WIDTH',
  'PRODUCT DEPTH (IN.)',
  'PRODUCT WIDTH (IN.)',
  'PRODUCT HEIGHT (IN.)',
  'PRICE',
  'HEIGHT - MAXIMUM (IN)',
  'DEPTH - DOOR SHUT (WITH HANDLE) (IN.)',
  'DEPTH - DOOR SHUT (WITHOUT HANDLE) (IN.)',
  'MICROWAVE PRODUCT WIDTH (IN.)',
  'MICROWAVE PRODUCT DEPTH (IN.)',
  'MICROWAVE PRODUCT HEIGHT (IN.)'
];

export const searchSortTypes = [
  {
    name: 'Best Match',
    sortby: 'bestmatch',
    sortorder: 'asc'
  },
  {
    name: 'Top Sellers',
    sortby: 'topsellers',
    sortorder: 'desc'
  },
  {
    name: 'Price Low to High',
    sortby: 'price',
    sortorder: 'asc'
  },
  {
    name: 'Price High to Low',
    sortby: 'price',
    sortorder: 'desc'
  },
  {
    name: 'Top Rated Products',
    sortby: 'toprated',
    sortorder: 'asc'
  }
];

export const browseSortTypes = [
  {
    name: 'Top Sellers',
    sortby: 'topsellers',
    sortorder: 'desc'
  },
  {
    name: 'Most Popular',
    sortby: 'mostpopular',
    sortorder: 'asc'
  },
  {
    name: 'Price Low to High',
    sortby: 'price',
    sortorder: 'asc'
  },
  {
    name: 'Price High to Low',
    sortby: 'price',
    sortorder: 'desc'
  },
  {
    name: 'Top Rated Products',
    sortby: 'toprated',
    sortorder: 'asc'
  }
];

export const DEFAULT_LAYOUT_STYLE = 'Grid';
export const LIST_LAYOUT_STYLE = 'List';
